import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const OverseaProductInfoService = () => {
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);
  return {
    product_info_map: product.product_info_map,
  };
};
